import type * as React from 'react'
import Container from '../../atoms/Container'

export type VideoCardProps = {
  style?: React.CSSProperties
  url: string
  className: string
}

export default function VideoCard({
  style,
  url,
  className
}: VideoCardProps): React.ReactElement {
  const videoStyle = {
    ...styles.videoCard,
    ...style
  }

  return (
    <Container style={styles.container}>
      <iframe
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        frameBorder="0"
        src={url}
        style={videoStyle}
        className={className}
        title="Embedded youtube"
      />
    </Container>
  )
}

const styles = {
  container: {
    padding: 0
  },
  videoCard: {
    borderRadius: 25
  }
}
